import React, { useState } from 'react'
import CardContainer from '../../../Shared/Card/CardContainer'
import { profile_icon } from '../../../Shared/icons'
import useForm from '../../../../hooks/useForm'
import EditExtdFields from '../../../Shared/User/EditExtdFields';
import { LoadingComponent, ValidateInput } from 'usbc-web-react-library'
import { useParams } from "react-router-dom";
import useApi from '../../../../hooks/useApi'
import { updateStepData } from '../../../Shared/helpers';


const requiredFieldMsg = (fieldName) => `Please enter ${fieldName}`;
const requiredSelectMsg = (fieldName) => `Please select ${fieldName}`;

function EditBowlerInfo(props) {
    let { lid, season } = useParams();

    const {
        handleChange,
        handleSubmit,
        setValues,
        updateError,
        values,
        errors
    } = useForm(savePersonCallback, validate);

    const {
        fetchData: getBowlerInfo,
        loading: bowlerInfoLoading,
        response:bowlerInfo
    } = useApi();

    React.useEffect(() => {
        getBowlerInfo({ url: 'getbowlerinfo/' + lid + '/00000-00000/' + season }).then(result => {
            let initialInfo = {};
            if (props.wizardState?.bowlerProfile) {
                initialInfo = props.wizardState?.bowlerProfile;
            } else {
                initialInfo = { country: "US" };
            }

            setValues(
                {
                    ...initialInfo,
                    extdFields:
                    {
                        ...result.extdFields,
                        ...props.wizardState?.bowlerProfile?.extdFields
                    }
                } || {});
        });
        if(props.wizardState?.requiresGuardianEmail){
            validate('guardianEmail', values?.guardianEmail, 'guardianEmail')
        }
    }, []);

    function formatPhoneNumber(value) {
        if (!value) return value;
        const phonenumber = value.replace(/[^\d]/g, '');
        const phonelength = phonenumber.length;
        if (phonelength < 4) return phonenumber;
        if (phonelength <= 6) return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3)}`;
        if (phonelength > 6 && phonelength < 10) return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3, 6)}-${phonenumber.slice(6)}`;
        if (phonelength > 10) return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3, 6)}-${phonenumber.slice(6, 10)} x${phonenumber.slice(10)}`;

        return `${phonenumber.slice(0, 3)}/${phonenumber.slice(3, 6)}-${phonenumber.slice(6)}`;
    }

    function savePersonCallback() {
        let stepData = props.wizardState;
        stepData = updateStepData(stepData, {
            bowlerProfile: values,
        })
        props.updateWizardState(stepData)
        props.nextView(stepData);
    }

    function validate(name, value, displayName) {
        let testValue = (value || "").trim();
        switch (name) {
            case 'firstName':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            case 'lastName':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            case 'email':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else if (
                    !new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(testValue)
                ) {
                    updateError(name, 'Please enter a valid email address');
                }
                else {
                    updateError(name);
                }
                break;
            case 'guardianEmail':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else if (
                    !new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(testValue)
                ) {
                    updateError(name, 'Please enter a valid email address');
                }
                else {
                    updateError(name);
                }
                break;
            case 'phone':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                }
                else {
                    testValue = formatPhoneNumber(testValue).replace(/( |-)+$/g, '');
                    if (!new RegExp(/\d{3}\/s*\d{3}-\d{4}( X\d{0,})?/gm).test(testValue)) {
                        updateError(name, 'Please enter a valid phone number in 999/999 9999 x9999 format');
                    }
                    else {
                        updateError(name);
                    }
                    value = testValue;
                }
                break;
            case 'competitionGenderClassification':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredSelectMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            case 'dateOfBirth':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredSelectMsg(displayName));
                } else {
                    let dateOfBirth = new Date(value);
                    if (dateOfBirth.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
                        updateError(name, "Birth Date should be in the past");
                    } else {
                        if (props.wizardState?.leagueCategory?.toLowerCase() === 'adult') {
                            const age = calculateAge(value);
                            if (age < 18) {
                                updateError(name, "You must be 18 years of age or older");
                            } else {
                                updateError(name);
                            }
                        } else {
                            updateError(name);
                        }
                    }
                }
                break;
            case 'address1':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            case 'city':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            case 'state':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredSelectMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            case 'zip':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredFieldMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            case 'country':
                if (testValue == null || testValue == "") {
                    updateError(name, requiredSelectMsg(displayName));
                } else {
                    updateError(name);
                }
                break;
            default:
                break;
        }
        return value;
    }

    function calculateAge(birthdate) {
        const currentDate = new Date();
        const birthdateObj = new Date(birthdate);

        let age = currentDate.getFullYear() - birthdateObj.getFullYear();

        // Check if the birthday has occurred this year
        if (
            birthdateObj.getMonth() > currentDate.getMonth() ||
            (birthdateObj.getMonth() === currentDate.getMonth() && birthdateObj.getDate() > currentDate.getDate())
        ) {
            age--;
        }

        return age;
    }

    return (
        <>
            <div className="row">
                <div className="col h4 wizard-step-title">
                    {props.step.title}
                </div>
            </div>
            <LoadingComponent isLoading={() => bowlerInfoLoading === true} description="Loading">
                {values !== null &&
                    <>
                        <div className="row g-0" >
                            <div className="col-md-3 center-parent stepIcon">
                                {profile_icon}
                            </div>
                            <div className="col-md-9" style={{ display: 'flex', alignItems: "center" }}>
                                <div className="card-body">
                                    {values !== null &&
                                        <CardContainer title="New Bowler Profile">
                                            <form id="userinfo-form" className="container" onSubmit={handleSubmit} noValidate>
                                                <div className='row'>
                                                    <div className="col-md-4">
                                                        <label htmlFor="firstName" className="form-label">First</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="text" className="form-control" id="firstName" name='firstName' value={values?.firstName || ""}
                                                                onChange={handleChange} maxLength={20} />
                                                        </ValidateInput>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="initial" className="form-label">MI</label>
                                                        <input type="text" className="form-control" id="initial" name='initial' value={values?.initial || ""} onChange={handleChange} maxLength={1} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="lastName" className="form-label">Last</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="text" className="form-control" id="lastName" name='lastName' value={values?.lastName || ""} onChange={handleChange} maxLength={30} />
                                                        </ValidateInput>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="suffix" className="form-label">Suffix</label>
                                                        <input type="text" className="form-control" id="suffix" name='suffix' value={values?.suffix || ""} onChange={handleChange} maxLength={7} />
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className="col-md-6">
                                                        <label htmlFor="competitionGenderClassification" className="form-label">Competition Gender Classification</label>
                                                        <ValidateInput errors={errors}>
                                                            <select className="form-select" id="competitionGenderClassification" name='competitionGenderClassification' value={values?.competitionGenderClassification || ""} onChange={handleChange}>
                                                                <option value="">Select</option>
                                                                <option value="M">Male/Open</option>
                                                                <option value="F">Female</option>
                                                            </select>
                                                        </ValidateInput>
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className="col-md-4">
                                                        <label htmlFor="dateOfBirth" className="form-label">Birth Date</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="Date" className="form-control" id="dateOfBirth" name='dateOfBirth' value={values?.dateOfBirth || ""} onChange={handleChange} />
                                                        </ValidateInput>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="email" className="form-label">Email</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="Email" className="form-control" id="email" name='email' value={values?.email || ""} onChange={handleChange} maxLength={50} />
                                                        </ValidateInput>
                                                    </div>
                                                    {props?.wizardState?.requiresGuardianEmail &&
                                                        <div className="col-md-4">
                                                            <label htmlFor="guardianEmail" className="form-label">Guardian Email</label>
                                                            <ValidateInput errors={errors}>
                                                                <input type="guardianEmail" className="form-control" id="guardianEmail" name='guardianEmail' value={values?.guardianEmail || ""} onChange={handleChange} maxLength={50} />
                                                            </ValidateInput>
                                                        </div>
                                                    }
                                                    <div className="col-md-4">
                                                        <label htmlFor="phone" className="form-label">Phone</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="text" className="form-control" id="phone" name='phone' placeholder='999/999-9999 x9999' value={values?.phone || ""} onChange={handleChange} maxLength={19} />
                                                        </ValidateInput>
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className="col-md-4">
                                                        <label htmlFor="address1" className="form-label">Address 1</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="text" className="form-control" id="address1" name='address1' value={values?.address1 || ""} onChange={handleChange} maxLength={30} />
                                                        </ValidateInput>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="address2" className="form-label">Address 2</label>
                                                        <input type="text" className="form-control" id="address2" name='address2' value={values?.address2 || ""} onChange={handleChange} maxLength={30} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="city" className="form-label">City</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="text" className="form-control" id="city" name='city' value={values?.city || ""} onChange={handleChange} maxLength={20} />
                                                        </ValidateInput>
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className="col-md-4">
                                                        <label htmlFor="state" className="form-label">State</label>
                                                        <ValidateInput errors={errors}>
                                                            <select className="form-select" id="state" name='state' value={values?.state || ""} onChange={handleChange}>
                                                                <option value="">Select</option>
                                                                <option value="AL">Alabama</option>
                                                                <option value="AK">Alaska</option>
                                                                <option value="AZ">Arizona</option>
                                                                <option value="AR">Arkansas</option>
                                                                <option value="CA">California</option>
                                                                <option value="CO">Colorado</option>
                                                                <option value="CT">Connecticut</option>
                                                                <option value="DE">Delaware</option>
                                                                <option value="DC">District Of Columbia</option>
                                                                <option value="FL">Florida</option>
                                                                <option value="GA">Georgia</option>
                                                                <option value="HI">Hawaii</option>
                                                                <option value="ID">Idaho</option>
                                                                <option value="IL">Illinois</option>
                                                                <option value="IN">Indiana</option>
                                                                <option value="IA">Iowa</option>
                                                                <option value="KS">Kansas</option>
                                                                <option value="KY">Kentucky</option>
                                                                <option value="LA">Louisiana</option>
                                                                <option value="ME">Maine</option>
                                                                <option value="MD">Maryland</option>
                                                                <option value="MA">Massachusetts</option>
                                                                <option value="MI">Michigan</option>
                                                                <option value="MN">Minnesota</option>
                                                                <option value="MS">Mississippi</option>
                                                                <option value="MO">Missouri</option>
                                                                <option value="MT">Montana</option>
                                                                <option value="NE">Nebraska</option>
                                                                <option value="NV">Nevada</option>
                                                                <option value="NH">New Hampshire</option>
                                                                <option value="NJ">New Jersey</option>
                                                                <option value="NM">New Mexico</option>
                                                                <option value="NY">New York</option>
                                                                <option value="NC">North Carolina</option>
                                                                <option value="ND">North Dakota</option>
                                                                <option value="OH">Ohio</option>
                                                                <option value="OK">Oklahoma</option>
                                                                <option value="OR">Oregon</option>
                                                                <option value="PA">Pennsylvania</option>
                                                                <option value="RI">Rhode Island</option>
                                                                <option value="SC">South Carolina</option>
                                                                <option value="SD">South Dakota</option>
                                                                <option value="TN">Tennessee</option>
                                                                <option value="TX">Texas</option>
                                                                <option value="UT">Utah</option>
                                                                <option value="VT">Vermont</option>
                                                                <option value="VA">Virginia</option>
                                                                <option value="WA">Washington</option>
                                                                <option value="WV">West Virginia</option>
                                                                <option value="WI">Wisconsin</option>
                                                                <option value="WY">Wyoming</option>
                                                            </select>
                                                        </ValidateInput>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="zip" className="form-label">Zip Code</label>
                                                        <ValidateInput errors={errors}>
                                                            <input type="text" className="form-control" id="zip" name='zip' value={values?.zip || ""} onChange={handleChange} pattern="[0-9]{5}" maxLength={'10'}
                                                                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} />
                                                        </ValidateInput>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="country" className="form-label">Country</label>
                                                        <ValidateInput errors={errors}>
                                                            <select className="form-select" id="country" name='country' value={values?.country || ""} onChange={handleChange} >
                                                                <option value="US">United States</option>
                                                                <option value="AF">Afghanistan</option>
                                                                <option value="AX">Aland Islands</option>
                                                                <option value="AL">Albania</option>
                                                                <option value="DZ">Algeria</option>
                                                                <option value="AS">American Samoa</option>
                                                                <option value="AD">Andorra</option>
                                                                <option value="AO">Angola</option>
                                                                <option value="AI">Anguilla</option>
                                                                <option value="AQ">Antarctica</option>
                                                                <option value="AG">Antigua and Barbuda</option>
                                                                <option value="AR">Argentina</option>
                                                                <option value="AM">Armenia</option>
                                                                <option value="AW">Aruba</option>
                                                                <option value="AU">Australia</option>
                                                                <option value="AT">Austria</option>
                                                                <option value="AZ">Azerbaijan</option>
                                                                <option value="BS">Bahamas</option>
                                                                <option value="BH">Bahrain</option>
                                                                <option value="BD">Bangladesh</option>
                                                                <option value="BB">Barbados</option>
                                                                <option value="BY">Belarus</option>
                                                                <option value="BE">Belgium</option>
                                                                <option value="BZ">Belize</option>
                                                                <option value="BJ">Benin</option>
                                                                <option value="BM">Bermuda</option>
                                                                <option value="BT">Bhutan</option>
                                                                <option value="BO">Bolivia</option>
                                                                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                                                                <option value="BA">Bosnia and Herzegovina</option>
                                                                <option value="BW">Botswana</option>
                                                                <option value="BV">Bouvet Island</option>
                                                                <option value="BR">Brazil</option>
                                                                <option value="IO">British Indian Ocean Territory</option>
                                                                <option value="BN">Brunei Darussalam</option>
                                                                <option value="BG">Bulgaria</option>
                                                                <option value="BF">Burkina Faso</option>
                                                                <option value="BI">Burundi</option>
                                                                <option value="KH">Cambodia</option>
                                                                <option value="CM">Cameroon</option>
                                                                <option value="CA">Canada</option>
                                                                <option value="CV">Cape Verde</option>
                                                                <option value="KY">Cayman Islands</option>
                                                                <option value="CF">Central African Republic</option>
                                                                <option value="TD">Chad</option>
                                                                <option value="CL">Chile</option>
                                                                <option value="CN">China</option>
                                                                <option value="CX">Christmas Island</option>
                                                                <option value="CC">Cocos (Keeling) Islands</option>
                                                                <option value="CO">Colombia</option>
                                                                <option value="KM">Comoros</option>
                                                                <option value="CG">Congo</option>
                                                                <option value="CD">Congo, Democratic Republic of the Congo</option>
                                                                <option value="CK">Cook Islands</option>
                                                                <option value="CR">Costa Rica</option>
                                                                <option value="CI">Cote D'Ivoire</option>
                                                                <option value="HR">Croatia</option>
                                                                <option value="CU">Cuba</option>
                                                                <option value="CW">Curacao</option>
                                                                <option value="CY">Cyprus</option>
                                                                <option value="CZ">Czech Republic</option>
                                                                <option value="DK">Denmark</option>
                                                                <option value="DJ">Djibouti</option>
                                                                <option value="DM">Dominica</option>
                                                                <option value="DO">Dominican Republic</option>
                                                                <option value="EC">Ecuador</option>
                                                                <option value="EG">Egypt</option>
                                                                <option value="SV">El Salvador</option>
                                                                <option value="GQ">Equatorial Guinea</option>
                                                                <option value="ER">Eritrea</option>
                                                                <option value="EE">Estonia</option>
                                                                <option value="ET">Ethiopia</option>
                                                                <option value="FK">Falkland Islands (Malvinas)</option>
                                                                <option value="FO">Faroe Islands</option>
                                                                <option value="FJ">Fiji</option>
                                                                <option value="FI">Finland</option>
                                                                <option value="FR">France</option>
                                                                <option value="GF">French Guiana</option>
                                                                <option value="PF">French Polynesia</option>
                                                                <option value="TF">French Southern Territories</option>
                                                                <option value="GA">Gabon</option>
                                                                <option value="GM">Gambia</option>
                                                                <option value="GE">Georgia</option>
                                                                <option value="DE">Germany</option>
                                                                <option value="GH">Ghana</option>
                                                                <option value="GI">Gibraltar</option>
                                                                <option value="GR">Greece</option>
                                                                <option value="GL">Greenland</option>
                                                                <option value="GD">Grenada</option>
                                                                <option value="GP">Guadeloupe</option>
                                                                <option value="GU">Guam</option>
                                                                <option value="GT">Guatemala</option>
                                                                <option value="GG">Guernsey</option>
                                                                <option value="GN">Guinea</option>
                                                                <option value="GW">Guinea-Bissau</option>
                                                                <option value="GY">Guyana</option>
                                                                <option value="HT">Haiti</option>
                                                                <option value="HM">Heard Island and Mcdonald Islands</option>
                                                                <option value="VA">Holy See (Vatican City State)</option>
                                                                <option value="HN">Honduras</option>
                                                                <option value="HK">Hong Kong</option>
                                                                <option value="HU">Hungary</option>
                                                                <option value="IS">Iceland</option>
                                                                <option value="IN">India</option>
                                                                <option value="ID">Indonesia</option>
                                                                <option value="IR">Iran, Islamic Republic of</option>
                                                                <option value="IQ">Iraq</option>
                                                                <option value="IE">Ireland</option>
                                                                <option value="IM">Isle of Man</option>
                                                                <option value="IL">Israel</option>
                                                                <option value="IT">Italy</option>
                                                                <option value="JM">Jamaica</option>
                                                                <option value="JP">Japan</option>
                                                                <option value="JE">Jersey</option>
                                                                <option value="JO">Jordan</option>
                                                                <option value="KZ">Kazakhstan</option>
                                                                <option value="KE">Kenya</option>
                                                                <option value="KI">Kiribati</option>
                                                                <option value="KP">Korea, Democratic People's Republic of</option>
                                                                <option value="KR">Korea, Republic of</option>
                                                                <option value="XK">Kosovo</option>
                                                                <option value="KW">Kuwait</option>
                                                                <option value="KG">Kyrgyzstan</option>
                                                                <option value="LA">Lao People's Democratic Republic</option>
                                                                <option value="LV">Latvia</option>
                                                                <option value="LB">Lebanon</option>
                                                                <option value="LS">Lesotho</option>
                                                                <option value="LR">Liberia</option>
                                                                <option value="LY">Libyan Arab Jamahiriya</option>
                                                                <option value="LI">Liechtenstein</option>
                                                                <option value="LT">Lithuania</option>
                                                                <option value="LU">Luxembourg</option>
                                                                <option value="MO">Macao</option>
                                                                <option value="MK">Macedonia, the Former Yugoslav Republic of</option>
                                                                <option value="MG">Madagascar</option>
                                                                <option value="MW">Malawi</option>
                                                                <option value="MY">Malaysia</option>
                                                                <option value="MV">Maldives</option>
                                                                <option value="ML">Mali</option>
                                                                <option value="MT">Malta</option>
                                                                <option value="MH">Marshall Islands</option>
                                                                <option value="MQ">Martinique</option>
                                                                <option value="MR">Mauritania</option>
                                                                <option value="MU">Mauritius</option>
                                                                <option value="YT">Mayotte</option>
                                                                <option value="MX">Mexico</option>
                                                                <option value="FM">Micronesia, Federated States of</option>
                                                                <option value="MD">Moldova, Republic of</option>
                                                                <option value="MC">Monaco</option>
                                                                <option value="MN">Mongolia</option>
                                                                <option value="ME">Montenegro</option>
                                                                <option value="MS">Montserrat</option>
                                                                <option value="MA">Morocco</option>
                                                                <option value="MZ">Mozambique</option>
                                                                <option value="MM">Myanmar</option>
                                                                <option value="NA">Namibia</option>
                                                                <option value="NR">Nauru</option>
                                                                <option value="NP">Nepal</option>
                                                                <option value="NL">Netherlands</option>
                                                                <option value="AN">Netherlands Antilles</option>
                                                                <option value="NC">New Caledonia</option>
                                                                <option value="NZ">New Zealand</option>
                                                                <option value="NI">Nicaragua</option>
                                                                <option value="NE">Niger</option>
                                                                <option value="NG">Nigeria</option>
                                                                <option value="NU">Niue</option>
                                                                <option value="NF">Norfolk Island</option>
                                                                <option value="MP">Northern Mariana Islands</option>
                                                                <option value="NO">Norway</option>
                                                                <option value="OM">Oman</option>
                                                                <option value="PK">Pakistan</option>
                                                                <option value="PW">Palau</option>
                                                                <option value="PS">Palestinian Territory, Occupied</option>
                                                                <option value="PA">Panama</option>
                                                                <option value="PG">Papua New Guinea</option>
                                                                <option value="PY">Paraguay</option>
                                                                <option value="PE">Peru</option>
                                                                <option value="PH">Philippines</option>
                                                                <option value="PN">Pitcairn</option>
                                                                <option value="PL">Poland</option>
                                                                <option value="PT">Portugal</option>
                                                                <option value="PR">Puerto Rico</option>
                                                                <option value="QA">Qatar</option>
                                                                <option value="RE">Reunion</option>
                                                                <option value="RO">Romania</option>
                                                                <option value="RU">Russian Federation</option>
                                                                <option value="RW">Rwanda</option>
                                                                <option value="BL">Saint Barthelemy</option>
                                                                <option value="SH">Saint Helena</option>
                                                                <option value="KN">Saint Kitts and Nevis</option>
                                                                <option value="LC">Saint Lucia</option>
                                                                <option value="MF">Saint Martin</option>
                                                                <option value="PM">Saint Pierre and Miquelon</option>
                                                                <option value="VC">Saint Vincent and the Grenadines</option>
                                                                <option value="WS">Samoa</option>
                                                                <option value="SM">San Marino</option>
                                                                <option value="ST">Sao Tome and Principe</option>
                                                                <option value="SA">Saudi Arabia</option>
                                                                <option value="SN">Senegal</option>
                                                                <option value="RS">Serbia</option>
                                                                <option value="CS">Serbia and Montenegro</option>
                                                                <option value="SC">Seychelles</option>
                                                                <option value="SL">Sierra Leone</option>
                                                                <option value="SG">Singapore</option>
                                                                <option value="SX">Sint Maarten</option>
                                                                <option value="SK">Slovakia</option>
                                                                <option value="SI">Slovenia</option>
                                                                <option value="SB">Solomon Islands</option>
                                                                <option value="SO">Somalia</option>
                                                                <option value="ZA">South Africa</option>
                                                                <option value="GS">South Georgia and the South Sandwich Islands</option>
                                                                <option value="SS">South Sudan</option>
                                                                <option value="ES">Spain</option>
                                                                <option value="LK">Sri Lanka</option>
                                                                <option value="SD">Sudan</option>
                                                                <option value="SR">Suriname</option>
                                                                <option value="SJ">Svalbard and Jan Mayen</option>
                                                                <option value="SZ">Swaziland</option>
                                                                <option value="SE">Sweden</option>
                                                                <option value="CH">Switzerland</option>
                                                                <option value="SY">Syrian Arab Republic</option>
                                                                <option value="TW">Taiwan, Province of China</option>
                                                                <option value="TJ">Tajikistan</option>
                                                                <option value="TZ">Tanzania, United Republic of</option>
                                                                <option value="TH">Thailand</option>
                                                                <option value="TL">Timor-Leste</option>
                                                                <option value="TG">Togo</option>
                                                                <option value="TK">Tokelau</option>
                                                                <option value="TO">Tonga</option>
                                                                <option value="TT">Trinidad and Tobago</option>
                                                                <option value="TN">Tunisia</option>
                                                                <option value="TR">Turkey</option>
                                                                <option value="TM">Turkmenistan</option>
                                                                <option value="TC">Turks and Caicos Islands</option>
                                                                <option value="TV">Tuvalu</option>
                                                                <option value="UG">Uganda</option>
                                                                <option value="UA">Ukraine</option>
                                                                <option value="AE">United Arab Emirates</option>
                                                                <option value="GB">United Kingdom</option>
                                                                <option value="UM">United States Minor Outlying Islands</option>
                                                                <option value="UY">Uruguay</option>
                                                                <option value="UZ">Uzbekistan</option>
                                                                <option value="VU">Vanuatu</option>
                                                                <option value="VE">Venezuela</option>
                                                                <option value="VN">Viet Nam</option>
                                                                <option value="VG">Virgin Islands, British</option>
                                                                <option value="VI">Virgin Islands, U.s.</option>
                                                                <option value="WF">Wallis and Futuna</option>
                                                                <option value="EH">Western Sahara</option>
                                                                <option value="YE">Yemen</option>
                                                                <option value="ZM">Zambia</option>
                                                                <option value="ZW">Zimbabwe</option>
                                                            </select>
                                                        </ValidateInput>
                                                    </div>
                                                </div>
                                                <div className='row mt-3'></div>
                                                {(!!values?.extdFields && Object.keys(values?.extdFields).length > 0) &&
                                                    <EditExtdFields onUserInfoSave={props.onUserInfoSave} bowlerProfile={values} />
                                                }
                                            </form>
                                        </CardContainer>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='wizard-buttons-container'>
                            <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView}>Back</button>
                            <button type="submit" form='userinfo-form' className="btn btn-primary bowl-btn">Next</button>
                        </div>
                    </>
                }
            </LoadingComponent>
        </>
    )
};

export default EditBowlerInfo;

